import { z } from 'zod';
import {
    IpgConfigCustomizationSchemaBySystemId,
    IpgConfigSchemaBySystemId,
} from '../../../backend_config.types';
import type {
    CloverIpgConfig,
    CloverIpgConfigCustomization,
} from '../../../types/ipg/clover/clover-backend-config.types';
import { CloverIpgSystemId } from '../../../types/ipg/clover/clover-system-constants';

export const CloverIpgConfigSchema: z.ZodType<CloverIpgConfig> =
    IpgConfigSchemaBySystemId[CloverIpgSystemId];

export const CloverIpgConfigCustomizationSchema: z.ZodType<CloverIpgConfigCustomization> =
    IpgConfigCustomizationSchemaBySystemId[CloverIpgSystemId];
